import {
    AccountBalanceOutlined,
    AccountBoxOutlined,
    AccessibilityNewOutlined,
    AnimationOutlined,
    ArticleOutlined,
    AssignmentIndOutlined,
    AttachFileOutlined,
    AutoGraphOutlined,
    BlockOutlined,
    BookOutlined,
    BugReportOutlined,
    CampaignOutlined,
    CastForEducationOutlined,
    CategoryOutlined,
    ChatBubbleOutlineOutlined,
    ContactMailOutlined,
    DesignServicesOutlined,
    Filter2Outlined,
    FormatListNumberedOutlined,
    FormatListNumberedRtlOutlined,
    FormatOverlineOutlined,
    FunctionsOutlined,
    GpsFixedOutlined,
    HomeOutlined,
    Inventory2Outlined,
    LanguageOutlined,
    LocalLibraryOutlined,
    ManageAccountsOutlined,
    MarkEmailUnreadOutlined,
    MergeTypeOutlined,
    NotificationsActiveOutlined,
    OutboxOutlined,
    PeopleAltOutlined,
    PersonOutlineOutlined,
    PointOfSaleOutlined,
    PriceChangeOutlined,
    ProductionQuantityLimitsOutlined,
    PublicOutlined,
    QuizOutlined,
    RequestPageOutlined,
    SchoolOutlined,
    ShoppingCartOutlined,
    SmartToyOutlined,
    SwitchAccessShortcutOutlined,
    TextSnippetOutlined,
    UpdateOutlined,
    VideoLibraryOutlined
} from "@mui/icons-material";

/**
 * Единый конфиг навигации.
 *
 * Поля пункта:
 *  - id        — стабильный ключ
 *  - title     — подпись
 *  - icon      — React-элемент иконки
 *  - to        — путь (если пункт ведёт на страницу)
 *  - header    — не ссылка, а заголовок раздела внутри группы
 *  - keywords  — дополнительные слова для поиска
 *  - roles     — если задано, пункт виден только этим ролям
 *  - children  — подпункты
 *
 * `to` должен совпадать с реальным маршрутом из App.js.
 * Группа с `hidden: true` остаётся в конфиге, но не показывается в меню.
 */
export const navigation = [
    {
        id: "overview",
        title: "Обзор",
        items: [
            {id: "dashboard", title: "Рабочий стол", icon: <HomeOutlined/>, to: "/panel", keywords: ["dashboard", "главная", "старт"]}
        ]
    },
    {
        id: "istudy",
        title: "iStudy",
        items: [
            {id: "content-header", title: "Контент", header: true},
            {id: "categories", title: "Категории", icon: <CategoryOutlined/>, to: "/categories", keywords: ["разделы"]},
            {id: "articles", title: "Статьи", icon: <ArticleOutlined/>, to: "/articles", keywords: ["блог", "публикации"]},
            {id: "tags", title: "Теги", icon: <FormatOverlineOutlined/>, to: "/tags", keywords: ["метки"]},
            {id: "videos", title: "Видео", icon: <VideoLibraryOutlined/>, to: "/videos"},
            {id: "files", title: "Файлы", icon: <AttachFileOutlined/>, to: "/files/upload", keywords: ["загрузка", "медиа"]},
            {id: "countries", title: "Страны", icon: <PublicOutlined/>, to: "/countries", keywords: ["география"]},

            {id: "institutions-header", title: "Учебные заведения", header: true},
            {id: "schools", title: "Школы", icon: <SchoolOutlined/>, to: "/schools", keywords: ["образование"]},
            {id: "school-types", title: "Типы школ", icon: <MergeTypeOutlined/>, to: "/typeschools"},
            {id: "school-gender", title: "Пол", icon: <PeopleAltOutlined/>, to: "/genderschoolinformations"},
            {id: "residences", title: "Проживание", icon: <HomeOutlined/>, to: "/residences"},
            {id: "universities", title: "Университеты", icon: <AccountBalanceOutlined/>, to: "/universities"},
            {id: "faculties", title: "Факультеты", icon: <AccountBalanceOutlined/>, to: "/faculties"},
            {id: "prep", title: "Программы подготовки", icon: <CastForEducationOutlined/>, to: "/universityPrepProgrammes"},
            {id: "courses", title: "Курсы", icon: <LocalLibraryOutlined/>, to: "/courses"},
            {id: "locations", title: "Локации", icon: <GpsFixedOutlined/>, to: "/locations"},
            {id: "programs", title: "Программы", icon: <AnimationOutlined/>, to: "/programs"},
            {id: "celebrities", title: "Выпускники", icon: <AccessibilityNewOutlined/>, to: "/celebrities"},

            {id: "clients-header", title: "Клиенты и заявки", header: true},
            {id: "clients", title: "Клиенты", icon: <AssignmentIndOutlined/>, to: "/clients"},
            {id: "leads", title: "Заявки", icon: <ShoppingCartOutlined/>, to: "/leads", keywords: ["лиды", "requests"]},
            {id: "notification-leads", title: "Заявки Notification-bot", icon: <NotificationsActiveOutlined/>, to: "/notificationLeads", keywords: ["bot", "лиды"]},
            {id: "chats", title: "Чаты", icon: <ChatBubbleOutlineOutlined/>, to: "/chats", keywords: ["чат", "переписка", "chat", "консоль"]},
            {id: "chats-banned", title: "Забаненные в чате", icon: <BlockOutlined/>, to: "/chats/banned", keywords: ["бан", "чат"]},
            {id: "chats-prompts", title: "Приглашения в чат", icon: <ChatBubbleOutlineOutlined/>, to: "/chats/prompts", keywords: ["чат", "приглашение", "текст", "prompt"]},
            {id: "candidates", title: "Кандидаты", icon: <PeopleAltOutlined/>, to: "/candidates"},
            {id: "candidate-types", title: "Типы кандидатов", icon: <FormatOverlineOutlined/>, to: "/candidatetypes"},

            {id: "marketing-header", title: "Маркетинг", header: true},
{id: "banners", title: "Баннеры", icon: <CampaignOutlined/>, to: "/banners", keywords: ["баннер", "попап", "акция", "banner"]},
            {id: "offline-conversions", title: "Офлайн-конверсии", icon: <AutoGraphOutlined/>, to: "/offlineConversions", keywords: ["метрика", "конверсии"]}
        ]
    },
    {
        id: "testing",
        title: "Many Tests",
        items: [
            {id: "results", title: "Результаты", icon: <AutoGraphOutlined/>, to: "/results"},
            {id: "request-prices", title: "Консультации по ценам", icon: <RequestPageOutlined/>, to: "/requestPrices"},
            {id: "checks", title: "Чеки", icon: <PointOfSaleOutlined/>, to: "/checks"},
            {id: "user-requests", title: "Обращения", icon: <ContactMailOutlined/>, to: "/userRequests"},
            {id: "orders", title: "Заказы", icon: <SwitchAccessShortcutOutlined/>, to: "/orders"},
            {
                id: "tests",
                title: "Тесты",
                icon: <QuizOutlined/>,
                children: [
                    {id: "tests-language", title: "Знание языка", to: "/language-level-tests"},
                    {id: "tests-placement", title: "Placement Test", to: "/iStudyOnlinePlacementTest"},
                    {id: "tests-placement-questions", title: "Placement Questions", to: "/onlinePlacementTestQuestions"}
                ]
            },
            {
                id: "cat4",
                title: "CAT4",
                icon: <FunctionsOutlined/>,
                children: [
                    {id: "cat4-categories", title: "Категории CAT4", to: "/main-category-tests"},
                    {id: "cat4-tests", title: "Тесты CAT4", to: "/cat_4_test"}
                ]
            },
            {id: "ai-products", title: "AI Product", icon: <SmartToyOutlined/>, to: "/aiProducts"},
            {
                id: "essays",
                title: "Эссе",
                icon: <TextSnippetOutlined/>,
                children: [
                    {id: "essays-admin", title: "Эссе (админка)", to: "/essays"},
                    {id: "essays-workplace", title: "Эссе (работа)", to: "/essayWorkPlace"}
                ]
            },
            {id: "products", title: "Продукты", icon: <ProductionQuantityLimitsOutlined/>, to: "/products"},
            {id: "test-articles", title: "Статьи тестов", icon: <ArticleOutlined/>, to: "/testArticles"},
            {id: "test-pages", title: "Страницы тестов", icon: <ArticleOutlined/>, to: "/testPages"},
            {id: "packs", title: "Пакеты", icon: <Inventory2Outlined/>, to: "/packs"},
            {id: "samples", title: "Samples", icon: <Filter2Outlined/>, to: "/samples"},
            {id: "global-sales", title: "Глобальные скидки", icon: <PriceChangeOutlined/>, to: "/global-sales"},
            {id: "test-users", title: "Пользователи тестирования", icon: <PersonOutlineOutlined/>, to: "/testUsers"},
            {id: "test-types", title: "Типы тестов", icon: <FormatOverlineOutlined/>, to: "/test-types"},
            {id: "languages", title: "Языки", icon: <LanguageOutlined/>, to: "/languages"}
        ]
    },
    {
        id: "mailing",
        title: "Рассылки",
        hidden: true,
        items: [

            {id: "mailing-types", title: "Типы рассылок", icon: <MergeTypeOutlined/>, to: "/mailingTypes"},
            {id: "email-messages", title: "Письма", icon: <MarkEmailUnreadOutlined/>, to: "/emailMessages"},
            {id: "subscribers", title: "Подписчики", icon: <ContactMailOutlined/>, to: "/subscribers"},
            {id: "subscriber-lists", title: "Списки подписчиков", icon: <FormatListNumberedOutlined/>, to: "/subscriberList"},
            {id: "mailings", title: "Рассылки", icon: <OutboxOutlined/>, to: "/mailing"},
            {
                id: "templates",
                title: "Шаблоны",
                icon: <DesignServicesOutlined/>,
                children: [
                    {id: "templates-header", title: "Header", to: "/header"},
                    {id: "templates-footer", title: "Footer", to: "/footer"}
                ]
            },
            {id: "senders", title: "Отправители", icon: <AccountBoxOutlined/>, to: "/sender"},
            {id: "queue", title: "Очередь", icon: <FormatListNumberedRtlOutlined/>, to: "/queue"},
            {id: "queue-history", title: "История отправки", icon: <UpdateOutlined/>, to: "/queueHistory"},
            {id: "mail-log", title: "Логи", icon: <BookOutlined/>, to: "/mailLog"}
        ]
    },
    {
        id: "system",
        title: "Система",
        items: [
            {id: "users", title: "Пользователи", icon: <ManageAccountsOutlined/>, to: "/users", roles: ["ROLE_ADMIN", "ROLE_DEVELOPER"]},
            {id: "roles", title: "Роли", icon: <AssignmentIndOutlined/>, to: "/roles", roles: ["ROLE_ADMIN", "ROLE_DEVELOPER"]},
            {id: "errors", title: "Ошибки", icon: <BugReportOutlined/>, to: "/errors", roles: ["ROLE_ADMIN", "ROLE_DEVELOPER"]}
        ]
    }
];

export const isPathActive = (pathname, to) => {
    if (!to) {
        return false;
    }
    if (pathname === to) {
        return true;
    }
    return pathname.startsWith(to + "/");
};

/** Плоский список ссылок для палитры команд и поиска. */
export const flattenNavigation = () => {
    const result = [];
    navigation.forEach((group) => {
        if (group.hidden) {
            return;
        }
        group.items.forEach((item) => {
            if (item.header) {
                return;
            }
            if (item.to) {
                result.push({
                    id: item.id,
                    title: item.title,
                    to: item.to,
                    icon: item.icon,
                    group: group.title,
                    keywords: item.keywords || []
                });
            }
            (item.children || []).forEach((child) => {
                if (child.to) {
                    result.push({
                        id: child.id,
                        title: `${item.title} · ${child.title}`,
                        to: child.to,
                        icon: item.icon,
                        group: group.title,
                        keywords: [item.title, child.title, ...(item.keywords || [])]
                    });
                }
            });
        });
    });
    return result;
};

/** Активный путь для подсветки и хлебных крошек. */
export const findTrail = (pathname) => {
    for (const group of navigation) {
        for (const item of group.items) {
            if (item.header) {
                continue;
            }
            if (item.to && isPathActive(pathname, item.to)) {
                return {group, item, child: null};
            }
            for (const child of item.children || []) {
                if (isPathActive(pathname, child.to)) {
                    return {group, item, child};
                }
            }
        }
    }
    return null;
};

export default navigation;

